import { useState, useEffect, useRef, useContext } from "react";
import FormItem from "./FormItem";
import { Row, Button } from "reactstrap";
import _ from "lodash";
import { getFormSection } from "./utils/utils"
import AuthContext from './AuthContext';
import Alert from '@mui/material/Alert';
import { SuccessMessage } from "./AdditionalComponents";
/**
 * A basic demonstration of how to use the step wizard
 */
// const Wizard = () => {
//   const [state, updateState] = useState({
//     form: {}
//     // transitions: {
//     //   enterRight: `${transitions.animated} ${transitions.enterRight}`,
//     //   enterLeft: `${transitions.animated} ${transitions.enterLeft}`,
//     //   exitRight: `${transitions.animated} ${transitions.exitRight}`,
//     //   exitLeft: `${transitions.animated} ${transitions.exitLeft}`,
//     //   intro: `${transitions.animated} ${transitions.intro}`
//     // }
//     // demo: true, // uncomment to see more
//   });

//   const updateForm = (key, value) => {
//     const { form } = state;

//     form[key] = value;
//     updateState({
//       ...state,
//       form
//     });
//   };

//   // Do something on step change
//   const onStepChange = (stats) => {
//     // console.log(stats);
//   };

//   const setInstance = (SW) =>
//     updateState({
//       ...state,
//       SW
//     });

//   const { SW, demo } = state;

//   return (
//     <div className="container">
//       <h3>React Step Wizard</h3>
//       <div className={"jumbotron"}>
//         <div className="row">
//           <div className={`col-12 col-sm-6 offset-sm-3 `}>
//             <StepWizard
//               onStepChange={onStepChange}
//               isHashEnabled
//               transitions={state.transitions} // comment out for default transitions
//               // nav={<Nav />}
//               instance={setInstance}
//             >
//               <First hashKey={"FirstStep"} update={updateForm} />
//               <Second form={state.form} />
//               <Last hashKey={"TheEnd!"} />
//             </StepWizard>
//           </div>
//         </div>
//       </div>
//       {demo && SW && <InstanceDemo SW={SW} />}
//     </div>
//   );
// };

// export default Wizard;

/** Demo of using instance */
// const InstanceDemo = ({ SW }) => (
//   <Fragment>
//     <h4>Control from outside component</h4>
//     <button className={"btn btn-secondary"} onClick={SW.previousStep}>
//       Previous Step
//     </button>
//     &nbsp;
//     <button className={"btn btn-secondary"} onClick={SW.nextStep}>
//       Next Step
//     </button>
//   </Fragment>
// );

// const ActionButtons = ({
//   currentStep,
//   firstStep,
//   goToStep,
//   lastStep,
//   nextStep,
//   previousStep,
//   totalSteps,
//   step
// }) => 
//   (
//     <div>
//       <Row style={{display: 'flex', flexDirection: 'row', margin: "20px"}}>
//         {currentStep > 1 && (
//             <Button onClick={previousStep} style={{margin: '5px'}}>Back</Button>
//         )}
//           {currentStep < totalSteps && (
//             <Button onClick={nextStep} style={{margin: '5px'}} >Next</Button>
//           )}
//           {currentStep === totalSteps && (
//             <Button onClick={lastStep} style={{margin: '5px'}}>Finish</Button>
//           )}
//       </Row>
//     </div>
//   );

const ActionButtons = ({ questions, validationType, type, form, childRef, ...props }) => {
  const [proceed, setProceed] = useState(false);
  const [isFinished, setIsFinished] = useState(false);

  const handleChildFormValidation = () => {
    let foundError = false;
    switch (validationType) {
      case "concent-warning":
        return foundError;
      case "information":
        if(_.isUndefined(form[type]) || _.isEmpty(form[type])){
            foundError = true;
            props.showErr(true);
            return foundError;
        }
        else {
          const keys = Object.keys(form[type]);
          for (let q of questions){
            for (const [index, key] of keys.entries()) {
              const form_question = form[type];
              if (q['question'] === key){
                if (!_.isEmpty(q['text_box'])){
                  for (const [i, field] of q['text_box'].entries()) {
                    const value = _.get(form_question, [key, field, 'text'], {});
                    const dependency_value = q["radio_dependency"][i];

                    if (!_.isEmpty(q['radio'])){
                      const radio_value = _.get(form_question, [key, 'radio-selection', 'radio'], {});
                      // const dependency_value = q["radio_dependency"][i];
                      // console.log(radio_value);
                      // console.log(dependency_value);
                      // console.log(value);
                      if (radio_value === dependency_value && _.isEmpty(value)){
                          foundError = true;
                          props.showErr(true);
                          return foundError;
                      } 
                      
                      if (_.isEmpty(radio_value) && q['required'][i]) {
                        foundError = true;
                        props.showErr(true);
                        return foundError;
                      }
                    }
                    if (_.isEmpty(value) && q['required'][i]){
                      if (_.isEmpty(dependency_value)){
                        foundError = true;
                        props.showErr(true);
                        return foundError;
                      }
                    }
                  }
                }
                else if (!_.isEmpty(q['radio']) && _.isEmpty(q['text_box'])){
                  const value = _.get(form_question, [key, 'radio-selection', 'radio'], {});

                  if (_.isEmpty(value) && q['required']){
                    foundError = true;
                    props.showErr(true);
                    return foundError;
                  }
                }
                else if (!_.isEmpty(q['checkbox'])){
                  const value = _.get(form_question, [key, 'checkbox-selection', 'checkbox'], {});
                  if (value !== true && q['required']){
                    foundError = true;
                    props.showErr(true);
                    return foundError;
                  }
                }
              }
              foundError = false;
              props.showErr(false);
            }
          }
          return foundError;
        }
    }
  };

  const handleBack = () => {
    props.previousStep();
  };

  const handleNext = () => {
    let foundError = handleChildFormValidation();
    setProceed(false);
    if (!foundError){
      props.nextStep();
      props.showErr(false);
      setProceed(true);
    }
  };
  const isProcessing = useRef(false);
  const handleFinish = () => {
    // setIsFinishing(true);
    if (isProcessing.current) return;
    isProcessing.current = true;
    setIsFinished(true);
    props.lastStep();
    props.completeCallback()
  };
  return (
    <div>
      <Row style={{display: 'flex', flexDirection: 'row', margin: "20px", justifyContent: "center", justifyItems: "center", textAlign: "center"}}>
        {props.currentStep > 1 && (
            <Button onClick={handleBack} style={{margin: '5px'}} disabled={isFinished}>Back</Button>
        )}
          {props.currentStep < props.totalSteps && (
            <Button onClick={handleNext} style={{margin: '5px'}} disabled={isFinished}>Next</Button>
          )}
          {props.currentStep === props.totalSteps && (
            <Button onClick={handleFinish} style={{margin: '5px'}} disabled={isFinished}>Finish</Button>
          )}
      </Row>
    </div>
  );
};


export const TokenAuthentication = ({ form, update, index, ...props }) => {
  const {auth, setAuth, login, logout} = useContext(AuthContext);
  // console.log(auth);
  const { isAuthenticated, loading, msg, email } = auth;
  const [token, setToken] = useState(null);
  const childRef = useRef(null);
  const handleTokenChange = (e) => {
    const { name, value } = e.target;
    setToken(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // if (loading) {
  //   return (
  //     // <div>Loading...</div>
  //     <div class="loading-overlay">
  //       <svg class="spinner" viewBox="0 0 50 50">
  //           <circle cx="25" cy="25" r="20" fill="none" stroke-width="5" stroke-linecap="round"/>
  //       </svg>
  //     </div>
  //   )
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(privacy);
    await login({token});
  };

  const questions = getFormSection(props.questions.form, "token-authentication"); 
  const isVisible = props.currentStep === index;
  // const msg = "test message";
  // console.log(props.currentStep);
  // console.log("index: " + index);

  return (
    <div style={{ display: isVisible ? "block" : "none", textAlign: "center" }}>
      <h5
        style={{ display:"flex", 
        flexDirection: "column", textAlign: "center",
        maxWidth: "100%", marginBottom: "5%" 
      }}>
        Token Authentication
      </h5>
      {isAuthenticated ? 
        (
          <>
            <SuccessMessage isSuccess={isAuthenticated} />
            <ActionButtons {...props} questions={[]} 
            validationType={"login"}
            type={"login"} form={form} childRef={childRef}/>
          </>
        ):
      (
      <>
        <form onSubmit={handleSubmit} style={{ textAlign: "center", justifyItems: "center", display: "grid" }}>
          <p className='unlock-text'>Please enter your authentication token below:</p>
          <input type="text" name="token" style={{ color: "black", margin: 0, marginBottom: "15px" }} onChange={handleTokenChange}/>
          {msg?(<Alert variant="filled" severity="error" color="warning" style={{ maxWidth: "400px" }}><p>{msg}</p></Alert>): (<></>)}
          <br/>
          <button type="submit">Authenticate</button>
        </form>
      </>
      )}
      {/* <ActionButtons {...props} questions={[]} 
      validationType={"login"}
      type={"login"} form={form} childRef={childRef}/> */}
    </div>
  );
  // const questions = getFormSection(props.questions.form, "token-authentication"); 
  // const isVisible = props.currentStep === index;

  // return (
  //   <div style={{ display: isVisible ? 'block' : 'none' }}>
  //     <h5
  //       style={{ display:"flex", 
  //       flexDirection: "column", textAlign: "center",
  //       maxWidth: "100%", marginBottom: "5%" 
  //     }}>
  //       Token Information
  //     </h5>
  //     {questions.map((q, index) => {
  //       return (
  //         <FormItem user={props.user} question={q.question} showQuestion={q.show_question} size={q.col_size} 
  //           required={q.required} radio={q.radio} radioDependency={q.radio_dependency} radioText={q.radio_text}
  //           currentStep={props.currentStep} textBox={q.text_box} textBoxType={q.text_box_type} textArea={q.text_area}
  //           checkbox={q.checkbox} checkboxText={q.checkbox_text} userCallback={props.assignUser}
  //           totalSteps={props.totalSteps} update={update} ref={childRef} q_type={"token-authentication"}/>
  //         );
  //       }
  //     )}
  //     <ActionButtons {...props} questions={questions} 
  //     validationType={"login"}
  //     type={"login"} form={form} childRef={childRef}/>
  //   </div>
  // );
};

export const PersonalInformation = ({ form, update, index, ...props }) => {
  const questions = getFormSection(props.questions.form, "personal-information"); 
  // const [bmiResult, setBmiResult] = useState("");
  const {auth, setAuth, login, logout} = useContext(AuthContext);
  // console.log(auth);
  // if (auth){
  //   const { isAuthenticated, loading, msg, email} = auth || {};
  // }
  const { isAuthenticated, loading, msg } = auth || {};
  const email = auth?.email ?? '';
  const [display, setDisplay] = useState("block");
  const childRef = useRef(null);
  const dataToPass = { 
    ...props, 
    childRef: childRef 
  };

  const calculateBMI = (heightCm, weightKg) => {
    const height = parseFloat(heightCm);
    const weight = parseFloat(weightKg);
    if (!height || !weight || height <= 0) return "";
    const heightMeters = height / 100;
    const bmi = weight / (heightMeters * heightMeters);

    return bmi.toFixed(2);
  };

  const subtitle = form?.["personal-information"];    
  const q = subtitle?.["Please enter your height (cm) and weight (kg)"];
  const height = q?.["Height (cm)"]?.text;
  const weight = q?.["Weight (kg)"]?.text;
  // console.log(form);
  // console.log(height);
  // console.log(weight);
  // if (height && weight) {
  //   let result = calculateBMI(height, weight);
  //   setBmiResult(result);
  // } else {
  //   setBmiResult("");
  // }

  const currentBmi = (height && weight) ? calculateBMI(height, weight) : "";

  // const questions = props.questions.form[1]['personal-information'];
  const isVisible = props.currentStep === index;

  return (
    <div style={{ display: isVisible ? 'block' : 'none' }}>
      <h5
        style={{ display:"flex", 
        flexDirection: "column", textAlign: "center",
        maxWidth: "100%", marginBottom: "5%" 
      }}>
        Personal Information
      </h5>
      {questions.map((q, index) => {
        return (
          <FormItem user={props.user} question={q.question} showQuestion={q.show_question} size={q.col_size} 
            required={q.required} radio={q.radio} radioDependency={q.radio_dependency} radioText={q.radio_text}
            currentStep={props.currentStep} textBox={q.text_box} textBoxType={q.text_box_type} textArea={q.text_area}
            checkbox={q.checkbox} checkboxText={q.checkbox_text} userCallback={props.assignUser}
            totalSteps={props.totalSteps} update={update} ref={childRef} q_type={"personal-information"}
            autofill={[{email: email, bmi: currentBmi}]}/>
          );
        }
      )}
      <ActionButtons {...props} questions={questions} 
      validationType={"information"}
      type={"personal-information"} form={form} childRef={childRef}/>
    </div>
  );
};

export const MedicalHistory = ({form, update, index, ...props }) => {
  const [display, setDisplay] = useState("block");
  const childRef = useRef(null); 
  const dataToPass = { 
    ...props, 
    childRef: childRef 
  };
  // const questions = props.questions.form[2]['medical-history'];
  const questions = getFormSection(props.questions.form, "medical-history"); 
  const isVisible = props.currentStep === index;

  return (
    <div style={{ display: isVisible ? 'block' : 'none' }}>
      <h5
        style={{ display:"flex", 
        flexDirection: "column", textAlign: "center",
        maxWidth: "100%", marginBottom: "5%" 
      }}>
        Medical History
      </h5>
      {questions.map((q, index) => {
        return (
          <FormItem user={props.user} question={q.question} showQuestion={q.show_question} size={q.col_size} 
            required={q.required} radio={q.radio} radioDependency={q.radio_dependency} radioText={q.radio_text}
            currentStep={props.currentStep} textBox={q.text_box} textBoxType={q.text_box_type} textArea={q.text_area}
            checkbox={q.checkbox} checkboxText={q.checkbox_text} userCallback={props.assignUser}
            totalSteps={props.totalSteps} update={update} ref={childRef} q_type={"medical-history"}/>
          );
        }
      )}
      <ActionButtons {...props} questions={questions} 
      validationType={"information"}
      type={"medical-history"} form={form} childRef={childRef}/>
    </div>
  );
};

export const CriteriaQuestions = ({form, update, index, ...props }) => {
  const [display, setDisplay] = useState("block");
  const childRef = useRef(null); 
  const dataToPass = { 
    ...props, 
    childRef: childRef 
  };
  // const questions = props.questions.form[3]['criteria-questions'];
  // console.log("PRINTING CRITERION QUESTIONS");
  // console.log(questions)

  const questions = getFormSection(props.questions.form, "criteria-questions"); 
  const isVisible = props.currentStep === index;

  return (
    <div style={{ display: isVisible ? 'block' : 'none' }}>
      <h5
        style={{ display:"flex", 
        flexDirection: "column", textAlign: "center",
        maxWidth: "100%", marginBottom: "5%" 
      }}>
        Criteria Questions
      </h5>
      {questions.map((q, index) => {
        return (
          <FormItem user={props.user} question={q.question} showQuestion={q.show_question} size={q.col_size} 
            required={q.required} radio={q.radio} radioDependency={q.radio_dependency} radioText={q.radio_text}
            currentStep={props.currentStep} textBox={q.text_box} textBoxType={q.text_box_type} textArea={q.text_area}
            checkbox={q.checkbox} checkboxText={q.checkbox_text} userCallback={props.assignUser}
            totalSteps={props.totalSteps} update={update} ref={childRef} q_type={"criteria-questions"}/>
          );
        }
      )}
      <ActionButtons {...props} questions={questions}
      validationType={"information"} 
      type={"criteria-questions"} form={form} childRef={childRef}/>
    </div>
  );
};

export const AdditionalInformation = ({form, update, index, ...props }) => {
  const [display, setDisplay] = useState("block");
  const childRef = useRef(null); 
  const dataToPass = { 
    ...props, 
    childRef: childRef 
  };
  // const questions = props.questions.form[4]['additional-information-and-confirmation'];
  // console.log("PRINTING CRITERION QUESTIONS");
  // console.log(questions)

  const questions = getFormSection(props.questions.form, "additional-information-and-confirmation"); 
  const isVisible = props.currentStep === index;
  // console.log("WE ARE IN THE ADDITIONAL INFO SECTION");
  // console.log(questions);

  return (
    <div style={{ display: isVisible ? 'block' : 'none' }}>
      <h5
        style={{ display:"flex", 
        flexDirection: "column", textAlign: "center",
        maxWidth: "100%", marginBottom: "5%" 
      }}>
        Additional Information and Confirmation
      </h5>
      {questions.map((q, index) => {
        return (
          <FormItem user={props.user} question={q.question} showQuestion={q.show_question} size={q.col_size} 
            required={q.required} radio={q.radio} radioDependency={q.radio_dependency} radioText={q.radio_text}
            currentStep={props.currentStep} textBox={q.text_box} textBoxType={q.text_box_type} textArea={q.text_area}
            checkbox={q.checkbox} checkboxText={q.checkbox_text} userCallback={props.assignUser}
            totalSteps={props.totalSteps} update={update} ref={childRef} q_type={"additional-information-and-confirmation"}/>
          );
        }
      )}
      <ActionButtons {...props} questions={questions}
      validationType={"information"} 
      type={"additional-information-and-confirmation"} form={form} childRef={childRef}/>
    </div>
  );
};

export const PrivacyConcent = ({form, update, index, ...props }) => {
  const submit = () => {
    // alert("You did it! Yay!"); // eslint-disable-line
  };

  const [display, setDisplay] = useState("block");
  const childRef = useRef(null); 
  const dataToPass = { 
    ...props, 
    childRef: childRef 
  };
  // const questions = props.questions.form[0]['privacy-concent'];  

  const questions = getFormSection(props.questions.form, "privacy-concent");  
  const isVisible = props.currentStep === index;

  return (
    <div style={{ display: isVisible ? 'block' : 'none' }}>
      <h5
        style={{ display:"flex", 
        flexDirection: "column", textAlign: "center",
        maxWidth: "100%", marginBottom: "5%" 
      }}>
        Privacy Notice
      </h5>
      <p style={{fontWeight: "bold"}} className="trial-heading">Introduction</p>
      <p className="trial-question">This Expression of Interest (EOI) form collects your personal and health information so that we can assess your 
        suitability for participation in a clinical trial conducted by Macquarie University and ISHCERF Centre. This Statement aligns with the BellaSeno 
        Privacy Statement and the Australian Privacy Principles (APPs).
      </p>
      <p style={{fontWeight: "bold"}} className="trial-heading">1. Who Is Collecting Your Information?</p>
      <p className="trial-question">Your information is collected by BellaSeno GmbH (BellaSeno), which hosts and manages this EOI website, on behalf of BellaSeno Pty Ltd. 
        BellaSeno and its related entities may also store or process your information through its subsidiaries, affiliates and authorised service providers in Australia.
      </p>
      <p style={{fontWeight: "bold"}} className="trial-heading">2. What Information We Collect</p>
      <p className="trial-question">We collect only the information reasonably necessary to assess your eligibility, including contact details, demographic information, 
        and relevant health information. By submitting this EOI, you consent to the collection and use of this sensitive personal information. 
        For further details about the types of sensitive personal information we collect and how we handle it, please refer to our Privacy Statement.
      </p>
      <p style={{fontWeight: "bold"}} className="trial-heading"> 3. How Your Information Will Be Used</p>
      <p className="trial-question">Your information will be used to assess your suitability for the trial, contact you for follow-up, support trial administration, and meet regulatory and ethical obligations.
      </p>
      <div style={{justifySelf: "center"}}>
      <p style={{fontWeight: "bold"}} className="trial-heading">4. Who Your Information May Be Disclosed To</p>
      <p className="trial-question">We may disclose your information to:
      </p>
      <div>
        <ul style={{listStyleType: "lower-alpha"}}>
          <li className="trial-list-text-2"> Macquarie University;</li>
          <li className="trial-list-text-2"> the ISHCERF Centre;</li>
          <li className="trial-list-text-2"> BellaSeno related entities;</li>
          <li className="trial-list-text-2"> Information technology and data storage service providers;</li>
          <li className="trial-list-text-2"> Regulatory authorities;</li>
          <li className="trial-list-text-2"> Clinical trial coordinators;</li>
          <li className="trial-list-text-2"> Surgeons and clinics; and</li>
          <li className="trial-list-text-2"> Human research ethics committees,</li>
        </ul>
      </div>
      <p className="trial-question">and some of these recipients may be located outside Australia.
      </p>
      </div>
      <p style={{fontWeight: "bold"}} className="trial-heading">5. How Your Information Is Stored and Protected</p>
      <p className="trial-question">BellaSeno uses encrypted systems, access controls, and secure servers to protect your personal information. Despite this, no internet transmission is completely secure.
      </p>
      <p style={{fontWeight: "bold"}} className="trial-heading">6. How Long We Keep Your Information</p>
      <p className="trial-question">Information will be retained only as long as necessary for EOI processing or as required under clinical or legal obligations.
        When no longer required, it will be securely deleted where permissible in accordance with the terms of our Privacy Statement.
      </p>
      <p style={{fontWeight: "bold"}} className="trial-heading">7. Your Rights</p>
      <p className="trial-question">You may request access to or correction of your information, withdraw your EOI, or lodge a privacy complaint. 
      </p>
      <p style={{fontWeight: "bold"}} className="trial-heading">8. Contact Details</p>
      <p className="trial-question">If you have any questions or comments about this Privacy Statement, or wish to access or correct your
        personal information or make a privacy complaint, please contact our Privacy Officer at:
      </p>
      <div style={{justifySelf: ""}}>
        <ul style={{listStyleType: "none"}}>
          <li style={{fontWeight: "bold"}} className="trial-list-text"> BellaSeno Pty Ltd</li>
          <li className="trial-list-text"> BellaSeno Pty Ltd</li>
          <li className="trial-list-text"> 4 Starling Street,</li>
          <li className="trial-list-text"> Burleigh Heads</li>
          <li className="trial-list-text"> Queensland 4220</li>
          {/* <li className="trial-list-text"> Tel: [Insert]</li> */}
          <li className="trial-list-text"> Email: BRV-005@mq.edu.au</li>
        </ul>
        <ul style={{listStyleType: "none"}}>
          <li className="trial-list-text"> Clinical Trials Coordinator</li>
          <li className="trial-list-text"> Macquarie University Breast Implant Study</li>
          <li className="trial-list-text"> Department of Plastic and Reconstructive Surgery</li>
          <li className="trial-list-text"> Suite 301, 2 Technology Place</li>
          <li className="trial-list-text"> Macquarie Park NSW 2109</li>
          <li className="trial-list-text"> Email: BRV-005@mq.edu.au</li>
        </ul>
      </div>

      <p className="trial-question">If you are not satisfied with our response, you may lodge a complaint with the Office of the Australian Information Commissioner (OAIC).
        Details on how to contact the OAIC are available in our Privacy Statement.</p>
      <br/>
      <br/>
      {questions.map((q, index) => {
        return (
          <FormItem user={props.user} question={q.question} showQuestion={q.show_question} size={q.col_size} 
            required={q.required} radio={q.radio} radioDependency={q.radio_dependency} radioText={q.radio_text}
            currentStep={props.currentStep} textBox={q.text_box} textBoxType={q.text_box_type} textArea={q.text_area}
            checkbox={q.checkbox} checkboxText={q.checkbox_text} userCallback={props.assignUser}
            totalSteps={props.totalSteps} update={update} ref={childRef} q_type={"privacy-concent"}/>
          );
        }
      )}
      <ActionButtons {...props} questions={questions}
      validationType={"information"} 
      type={"privacy-concent"} form={form} childRef={childRef}/>
    </div>
  );
};

export const Completion = ({setHoneypot, isFinished, ...props}) => {
  const submit = () => {
    // alert("You did it! Yay!");
  };

  const HoneypotField = ({ value, onChange }) => {
    return (
      <div style={{ 
        opacity: 0, 
        position: 'absolute', 
        top: 0, 
        left: 0, 
        height: 0, 
        width: 0, 
        zIndex: -1 
      }}>
        {/* <label htmlFor="confirm_email_address">Please leave this field empty</label> */}
        <input
          autoComplete="off"
          type="text"
          id="confirm_email_address"
          name="confirm_email_address"
          value={value}
          onChange={(e) => setHoneypot(e.target.value)}
          tabIndex="-1" // Prevents humans from "Tabbing" into the hidden field
        />
      </div>
    );
  };

  return (
    <div>
      <div style={{ justifyContent: "center", justifyItems: "center", textAlign: "center" }}>
        <h5>Thank you for your interest. Click Finish to submit your EOI to the trial team.</h5>
      </div>
      <HoneypotField />
      <ActionButtons {...props} nextStep={submit} />
    </div>
  );
};
